// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"273":"31e62301821be174acc2","702":"cec7efdf5911a556f086","715":"19c321a477a56f0a2c62"}[chunkId] + ".css";
};